module.exports = __webpack_public_path__ + "img/assignedto_dd.c65b75d5.png";